import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpBaseService } from './http-base.service';
import { PropertyType } from '../enums';

export interface ColumnInferenceRequest {
    columnName: string;
    sampleValues: string[];
}

export interface ColumnInferenceResponse {
    nameFr: string;
    nameEn: string;
    labelFr: string;
    labelEn: string;
    type: PropertyType;
}

@Injectable({
    providedIn: 'root'
})
export class AiService extends HttpBaseService {
    private readonly baseEndpoint = 'api/AI';

    /**
     * Inférer les propriétés d'une colonne basées sur son nom et des échantillons de valeurs
     */
    inferColumnProperties(request: ColumnInferenceRequest): Observable<ColumnInferenceResponse> {
        return this.post<ColumnInferenceResponse>(`${this.baseEndpoint}/infer-column`, request);
    }

    /**
     * Inférer les propriétés de plusieurs colonnes en lot
     */
    inferMultipleColumns(requests: ColumnInferenceRequest[]): Observable<ColumnInferenceResponse[]> {
        return this.post<ColumnInferenceResponse[]>(`${this.baseEndpoint}/infer-columns-batch`, requests);
    }

    /**
     * Traduire un texte vers l'anglais
     */
    translateToEnglish(text: string): Observable<{ translation: string }> {
        return this.post<{ translation: string }>(`${this.baseEndpoint}/translate-to-en`, { text });
    }

    /**
     * Traduire un texte vers le français
     */
    translateToFrench(text: string): Observable<{ translation: string }> {
        return this.post<{ translation: string }>(`${this.baseEndpoint}/translate-to-fr`, { text });
    }
}